/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'


import { Paper, Typography, Collapse, Tabs, Tab, CircularProgress, Badge } from '@material-ui/core'

import { ExpandMore, ExpandLess } from '@material-ui/icons'

import Filter from '../components/UtilComps/Filter'
import GroupTable from '../components/Groups/GroupTable'
import GroupDetail from '../components/Groups/GroupDetail'

import IFCSummary from '../components/UtilComps/IFCSummary'

import Actions from '../../../../fluid/Actions/ActionFactory'

import GlobalFieldList from '../components/UtilComps/GlobalFieldList';


const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);
  
const AntTab = withStyles((theme) => ({
    root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&:focus': {
        color: '#40a9ff',
      },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);


const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    badge: {
        padding: `0 ${theme.spacing.unit * 0}px`,
    }
})

class GroupSpace extends Component {
    state = {
        summary_open : false,
        group_tab_index : 0,
        filter : {
            direction : "Top",
            count : 50,
            range : [0, 50]
        }
    }

    stateChange = (key, value) => {
        this.setState({...this.state, [key] : value})
    }

    getLevel2Height = () => {
        let level2height = this.props.space_height - 50
        return level2height
    }

    getBodyHeight = () => {
        let bodyHeight = this.props.space_height - 100
        return bodyHeight
    }

    renderSummary = () => {
        return (
            <div style = {{width : '100%', height : this.getLevel2Height() + 'px', backgroundColor : '#F5F5F5'}}>
                <IFCSummary body_height = {this.getLevel2Height()} report_info = {this.props.report_info} low_count_drops = {this.props.low_count_drops}/>
            </div>
        )
    }

    renderLevel1 = () => {
        return (
            <div>
                <Paper 
                    square 
                    variant = 'outlined' 
                    style = {{
                        width : '100%', 
                        height : '50px',
                        display : 'flex',
                        flexDirection : 'row'
                    }}>
                        <div 
                            style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', paddingLeft : '10px', flexGrow : 1}}
                        >
                            <div>
                                <Typography variant = 'subtitle2'>{this.props.ic_name}</Typography>
                                <Typography variant = 'caption'>Version : </Typography>
                                <Typography variant = 'caption' display = 'inline' color = "primary">{this.props.version}</Typography>
                            </div>
                        </div>
                        <div 
                            style = {{display: 'flex', flexDirection : 'row-reverse', alignItems : 'center', paddingRight : '10px', cursor : "pointer"}}
                            onClick = {() => this.stateChange("summary_open", !this.state.summary_open)}
                        >
                                <div>
                                    <Typography style = {{userSelect : 'none'}} variant = 'caption' color = 'primary'>{this.state.summary_open ? "Close Summary" : "View Summary"}</Typography>
                                    {this.state.summary_open ? <ExpandLess color = "primary"/> : <ExpandMore color = "primary"/>}
                                </div>
                        </div>
                </Paper>
                <Collapse in = {this.state.summary_open}>
                    {this.renderSummary()}
                </Collapse>
            </div>
        )
    }

    renderLevel2 = () => {
        const { classes } = this.props
        return (
            <div style = {{width : '100%', height : '50px'}}>
                <AntTabs
                    value={this.state.group_tab_index}
                    indicatorColor="primary"
                    textColor="primary"
                    variant = 'scrollable'
                    scrollButtons="auto"
                    onChange = {(event, newValue) => this.stateChange("group_tab_index", newValue)}
                >
                    <AntTab label = {"All " + this.props.group_display_name + "s (" + this.props.report_info.group_ids.length + ")"}/>
                    <AntTab 
                        disabled = {this.props.pinned_groups.length === 0}
                        label = {
                            <Badge
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                // className={classes.badge}
                                overlap="rectangle"
                                badgeContent={this.props.pinned_groups.length}
                            >
                                {"Pinned " + this.props.group_display_name + "s "}
                            </Badge>
                        }
                    />
                    <AntTab label = {this.props.global_field_display_name + " Fields"}/>
                </AntTabs>
            </div>
        )
    }

    renderBody = () => {
        if (this.props.groups) {
            return (
                <div style = {{width : '100%', height : this.getBodyHeight() + 'px', overflow : 'hidden', padding : '5px'}}>
                    {this.renderTabPanels()}
                </div>
            )
        } else {
            if (this.props.loading_groups) {
                return (
                    <div 
                        style = {{
                            width : '100%', 
                            height : this.getBodyHeight() + 'px', 
                            overflow : 'hidden', 
                            padding : '5px', 
                            display : 'flex', 
                            flexDirection : "row", 
                            justifyContent : 'center', 
                            alignItems : 'center'
                        }}
                    >
                        <CircularProgress variant = 'indeterminate' color = 'primary'/>    
                    </div>
                )
            } else {
                
            }
        }
    }

    renderTabPanels = () => {
        switch (this.state.group_tab_index) {
            case 0:
                return this.renderAllGroups()
            case 1:
                return this.renderPinnedGroups()
            case 2:
                return this.renderGlobalFields()
            default:
                return this.renderAllGroups()
        }
    }

    renderAllGroups = () => {
        return (
            <div style = {{width : '100%', height : '100%'}}>
                {/* <div style = {{width : '100%', height : '50px'}}>
                    <Filter 
                        key = {'group_filter'} 
                        report_info = {this.props.report_info} 
                        count_field = {"num_field_groups"}
                        group_filter = {this.props.group_filter}
                        update_filter = {(group_filter) => this.props.update_filter(group_filter)}
                        sort_by = {
                            [
                                {
                                    annot : "Size",
                                    value : "size"
                                },
                                {
                                    annot : "Rank",
                                    value : "score"
                                }
                            ]
                        }
                    />
                </div> */}
                {this.renderGroupTable()}
            </div>
        )
    }

    renderGroupTable = () => {
        let columns = ["$pin", "$icon", "Name", "Fields", "Score", "$options"]
        return (
            <GroupTable 
                ic_name = {this.props.ic_name} 
                version = {this.props.version} 
                global_field_display_name = {this.props.global_field_display_name}
                group_display_name = {this.props.group_display_name}
                field_display_name = {this.props.field_display_name}
                body_height = {this.getBodyHeight() - 50} 
                top_margin = "0px" 
                score_field = "group_score"
                column_index = {this.props.column_index}
                columns = {columns}
                groups = {this.props.groups} 
                pinned_groups = {this.props.pinned_groups}
                group_filter = {this.props.group_filter}
                show_search = {true}
                update_filter = {(group_filter) => this.props.update_filter(group_filter)}
                search_label = {"Search All " + this.props.group_display_name + "s"}
                pin_group = {(group_id, action) => this.props.pin_group(group_id, action)}
                focus_group = {(group_object) => this.props.focus_group(group_object, "All Groups", () => this.props.update_space_state(0, 'group_detail'))}
                delete_group = {(group_data) => this.props.delete_group(group_data)}
            />
        )
    }

    renderPinnedGroups = () => {
        let pinned_groups = this.props.pinned_groups.map(pinned_group_id => {
            let group_object = this.props.groups.find(group => group.group_id === pinned_group_id)
            return group_object
        })

        let columns = ["$pin", "$icon", "Name", "Fields", "Score", "$options"]

        return (
            <div style = {{width : '100%', height : '100%'}}>
                <GroupTable 
                    ic_name = {this.props.ic_name} 
                    version = {this.props.version} 
                    global_field_display_name = {this.props.global_field_display_name}
                    group_display_name = {this.props.group_display_name}
                    field_display_name = {this.props.field_display_name}
                    body_height = {this.getBodyHeight()} 
                    top_margin = "0px" 
                    columns = {columns}
                    score_field = "group_score"
                    groups = {pinned_groups}
                    pinned_groups = {this.props.pinned_groups}
                    pin_group = {(group_id, action) => this.props.pin_group(group_id, action)}
                    group_filter = {this.props.group_filter}
                    update_filter = {(group_filter) => this.props.update_filter(group_filter)}
                    show_search = {false}
                    search_label = {"Search Pinned " + this.props.group_display_name + "s"}
                    focus_group = {(group_object) => this.props.focus_group(group_object, "Pinned Groups", () => this.props.update_space_state(0, 'group_detail'))}
                    delete_group = {(group_data) => this.props.delete_group(group_data)}
                />
            </div>
        )
    }

    renderGlobalFields = () => {
        var toPX = require('to-px')
        return (
            <div style = {{width : '100%', height : this.getBodyHeight() + 'px', overflow : 'hidden'}}>
                <GlobalFieldList
                    ic_name = {this.props.ic_name} 
                    version = {this.props.version} 
                    global_field_display_name = {this.props.global_field_display_name}
                    width = {toPX("25vw") - 10}
                    height = {this.getBodyHeight() - 100}
                    global_fields = {this.props.global_fields}
                    field_in_focus = {this.props.field_in_focus}
                    search_label = {"Search " + this.props.global_field_display_name + " fields"}
                    mapping_global_field = {this.props.mapping_global_field}
                    //focus_field = {(field_object, field_type, chained_func) => this.props.focus_field(field_object, field_type, chained_func)}
                    select_global_field = {(global_field) => this.props.focus_global_field(global_field.global_field)}
                    group_in_focus = {this.props.group_in_focus}
                    cursor = "pointer"
                    show_options = {true}
                    show_search = {true}
                    refresh_report_and_data = {this.props.refresh_report_and_data}
                />
            </div>
        )
    }

    renderGroupDetail = () => {
        return (
            <GroupDetail 
                global_field_display_name = {this.props.global_field_display_name}
                group_display_name = {this.props.group_display_name}
                field_display_name = {this.props.field_display_name}
                body_height = {this.getBodyHeight() + 50} 
                group_data = {this.props.group_in_focus} 
                global_fields = {this.props.global_fields}
                global_fields_error = {this.props.global_fields_error}
                mapping_global_field = {this.props.mapping_global_field}
                map_global_field = {(entity_id, global_field) => this.props.map_global_field(entity_id, global_field)}
                create_global_field = {(entity_id, new_field_name) => this.props.create_global_field(entity_id, new_field_name)}
                pinned_groups = {this.props.pinned_groups}
                pin_group = {(group_id, action) => this.props.pin_group(group_id, action)}
                from = {this.props.group_in_focus_from}
                unfocus_group = {() => this.props.focus_group(null, null, () => this.props.update_space_state(0, 'group_list'))}
                allow_name_edit = {true}
                location = {'GroupSpace'}
                ic_name = {this.props.ic_name} 
                version = {this.props.version} 
                refresh_space = {(group_id) => this.props.get_groups(group_id, this.props.group_in_focus_from)}
                field_in_focus = {this.props.field_in_focus}
                focus_field = {(field_object, field_type, chained_func) => this.props.focus_field(field_object, field_type, chained_func)}
                accept_field_drops = {true}
                move_field = {(field_data, field_type, drop_result) => this.props.move_field(field_data, field_type, drop_result)}
                syncing_field = {this.props.syncing_field}
                column_index = {this.props.column_index}
                update_space_state = {(index, state) => this.props.update_space_state(index, state)}
                unsynced_fields = {this.props.unsynced_fields}
                create_new_group_from_field = {(field_data) => this.props.create_new_group_from_field(field_data)}
                make_singleton = {(field_data) => this.props.make_singleton(field_data)}
                checking_merge_groups = {this.props.checking_merge_groups}
                group_filter = {this.props.group_filter}
                update_filter = {(group_filter) => this.props.update_filter(group_filter)}
            />
        )
    }

    render() { 
        const { classes } = this.props
        return (
            <div style = {{width : '100%', height : '100%', overflow : 'hidden'}}>
                {this.renderLevel1()}
                {this.props.group_in_focus !== null && this.renderGroupDetail()}
                {this.props.group_in_focus === null && this.renderLevel2()}
                {this.renderBody()}
            </div>
        );
    }
}
 
export default withStyles(styles)(GroupSpace);